import React from 'react';
import './ThreeDCard.css';
import FujiMountain from '../../../assets/imgs/fuji.png';
import getDrawings from '../../../api/getDrawings';

export default class ThreeDCard extends React.Component {
  state = {
    drawings: null,
    numberOfDrawings: 0,
    index:0
  }

  componentDidMount(){
    getDrawings()
    .then(res => {
      if(res.status === 200){
        this.setState(
          {
            drawings:res.drawings,
            numberOfDrawings:res.drawings.length,
          }
        )
      }
    })
  }

  handleAnimation = (event) => {
    const clientX = event.clientX;
    const clientY = event.clientY;
    const picRight = window.innerWidth/2+ event.target.offsetWidth/2;
    const picBottom = window.innerHeight/2+ event.target.offsetHeight/2;
    const rotateY = ((picRight - clientX)-event.target.offsetWidth/2)/window.innerWidth*40;
    const rotateX = (event.target.offsetHeight/2-(picBottom - clientY))/window.innerHeight*40;
    
    event.target.closest("img").style.transform=`rotateY(${rotateY}deg) rotateX(${rotateX}deg)`
  }

  handleChangePicture = () => {
    if(this.state.index < this.state.numberOfDrawings-1) {
      this.setState({index:this.state.index+1});
    }else{
      this.setState({index:0});
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    }
  }
  
  render() {
    const {drawings, index} = this.state;

    return (
      <>
        <h5>3D card</h5>
        <div className="threeDCard-content">
          <div className="img-container">
            <button onClick={this.handleChangePicture}>NEXT</button>
            <img
              src={drawings=== null ? FujiMountain: drawings[index].imgUrl}
              alt="drawing"
              onClick={(e) => this.handleAnimation(e)}
            />
            <div>Author: {drawings === null?"":drawings[index].author}</div>
          </div>         
        </div>
      </>
    )
  }
}